// The hills page: one card per venue, linking to its page (editable in Web Admin; starting
// text in backend/site_content/hills-*.md).
// Images are from the old Wix site. `match` lists the starts of the names a
// venue goes by in the calendar and results (lower case), so a hill page can
// list that venue's photo albums: "Hartland B" and "Hartland D" are both
// Hartland Quay, and Oliver's Mount is "Scarborough" in our results.
// backend/venues.py keeps the same names and matches for the photo album
// titles (a test checks the two agree).

const HILLS = [
  {
    "slug": "hills-castle",
    "name": "Castle",
    "image": "/site/content/d16ff9_c5bbba23a2e348ea8141b2e510fbf953.jpg",
    "match": [
      "castle"
    ]
  },
  {
    "slug": "hills-curborough",
    "name": "Curborough",
    "image": "/site/content/d16ff9_2e9e8fb536424968b774884d80ccfaad.jpg",
    "match": [
      "curborough"
    ]
  },
  {
    "slug": "hills-eppynt",
    "name": "Eppynt",
    "image": "/site/content/d16ff9_a7a2821109f74a0d83d537d7c1a2c70a.jpg",
    "match": [
      "eppynt"
    ]
  },
  {
    "slug": "hills-gurston-down",
    "name": "Gurston Down",
    "image": "/site/content/d16ff9_4829d89bbb7b44149c73328c35af4aa1.jpg",
    "match": [
      "gurston"
    ]
  },
  {
    "slug": "hills-hartland-quay",
    "name": "Hartland Quay",
    "image": "/site/content/d16ff9_91d6be30bddf4cf091dc9a3e364f27ef.jpg",
    "match": [
      "hartland"
    ]
  },
  {
    "slug": "hills-loton-park",
    "name": "Loton Park",
    "image": "/site/content/d16ff9_b014e8a14583462784d3b7f144cc0a30.jpg",
    "match": [
      "loton"
    ]
  },
  {
    "slug": "hills-manor-farm",
    "name": "Manor Farm",
    "image": "/site/content/d16ff9_8b6f3c1080a1410f8296aff3e5fc2023.jpg",
    "match": [
      "manor"
    ]
  },
  {
    "slug": "hills-olivers-mount",
    "name": "Oliver's Mount",
    "image": "/site/content/d16ff9_040282888aec44ff9c011846065681c2.jpg",
    "match": [
      "oliver",
      "scarborough"
    ]
  },
  {
    "slug": "hills-prescott",
    "name": "Prescott",
    "image": "/site/content/d16ff9_aa1dc9803f0844bcb5b9e85252a4bbc9.jpg",
    "match": [
      "prescott"
    ]
  },
  {
    "slug": "hills-shelsley-walsh",
    "name": "Shelsley Walsh",
    "image": "/site/content/d16ff9_e7b42fe3b13b40169781f133cac6905e.gif",
    "match": [
      "shelsley"
    ]
  },
  {
    "slug": "hills-tregrehan",
    "name": "Tregrehan",
    "image": "/site/content/d16ff9_d7e6669b84d547f698e3d8126375d7c9.jpg",
    "match": [
      "tregrehan"
    ]
  },
  {
    "slug": "hills-wiscombe-park",
    "name": "Wiscombe Park",
    "image": "/site/content/d16ff9_0d5fc3ec64c347dabedaadf0f6b8bb43.jpg",
    "match": [
      "wiscombe"
    ]
  }
];

export default HILLS;
